import { useEffect } from 'react';

function isTyping(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName);
}

/** Grid's keys: `n` new task, `/` search, Esc closes the drawer. Letters are ignored while typing. */
export function useGridShortcuts({
  onNew,
  onSearch,
  onEscape,
}: {
  onNew: () => void;
  onSearch: () => void;
  onEscape: () => void;
}) {
  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.altKey) return;
      if (e.key === 'Escape') {
        onEscape();
        return;
      }
      if (isTyping(e.target)) return;
      if (e.key === 'n') {
        e.preventDefault();
        onNew();
      } else if (e.key === '/') {
        e.preventDefault();
        onSearch();
      }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onNew, onSearch, onEscape]);
}
